import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { Geolocation } from '@capacitor/geolocation'
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'

export const isNative = () => Capacitor.isNativePlatform()

export function onAppVisible(callback: () => void): () => void {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') callback()
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)
  const listener = isNative() ? App.addListener('appStateChange', ({ isActive }) => { if (isActive) callback() }) : null
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    void listener?.then(handle => handle.remove())
  }
}

export async function getCurrentLocation(): Promise<{ lat: number; lng: number } | null> {
  if (isNative()) {
    try {
      const permission = await Geolocation.checkPermissions()
      if (permission.location !== 'granted' && permission.coarseLocation !== 'granted') {
        await Geolocation.requestPermissions({ permissions: ['location'] })
      }
      const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 10_000, maximumAge: 0 })
      return { lat: position.coords.latitude, lng: position.coords.longitude }
    } catch { return null }
  }
  if (!navigator.geolocation) return Promise.resolve(null)

  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      position => resolve({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 10_000, maximumAge: 0 },
    )
  })
}

export function readSelectedFiles(input: HTMLInputElement): File[] {
  return Array.from(input.files ?? [])
}

export async function takePhoto(): Promise<File | null> {
  try {
    const photo = await Camera.getPhoto({ quality: 85, resultType: CameraResultType.Uri, source: CameraSource.Camera, saveToGallery: false })
    if (!photo.webPath) throw new Error('A câmera não retornou a foto.')
    const response = await fetch(photo.webPath)
    const blob = await response.blob()
    return new File([blob], `entrega-${Date.now()}.${photo.format}`, { type: blob.type || `image/${photo.format}` })
  } catch (error) {
    if (error instanceof Error && /cancel/i.test(error.message)) return null
    throw error
  }
}
